/*
 * DAW · Section « Newsletter » — inscription à la lettre.
 *
 * Une seule donnée demandée : l'adresse e-mail. Pas de téléphone — il n'a de sens
 * que pour les alertes de drop, où le SMS fait gagner des minutes.
 *
 * L'envoi passe par l'API client de Klaviyo (`/client/subscriptions/`), la même
 * que le formulaire des drops, mais sur une AUTRE liste : celle de la newsletter.
 * Le double opt-in éventuel est géré par Klaviyo au niveau de la liste.
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  var REVISION = '2026-07-15';

  function isEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
  }

  function init(root) {
    var key = root.getAttribute('data-key');
    var list = root.getAttribute('data-list');
    var source = root.getAttribute('data-source') || 'Newsletter';
    var success = root.getAttribute('data-success') || 'Merci, c’est enregistré.';
    var form = root.querySelector('[data-daw-nl-form]');
    if (!key || !list || !form) return;

    var emailEl = root.querySelector('[data-daw-nl-email]');
    var submitEl = root.querySelector('[data-daw-nl-submit]');
    var msgEl = root.querySelector('[data-daw-nl-msg]');

    function say(text, kind) {
      if (!msgEl) return;
      msgEl.textContent = text;
      msgEl.className = 'daw-nl__msg daw-nl__msg--' + kind;
      msgEl.hidden = false;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var email = (emailEl && emailEl.value ? emailEl.value : '').trim();
      if (!isEmail(email)) {
        say('Merci de saisir une adresse e-mail valide.', 'ko');
        if (emailEl) emailEl.focus();
        return;
      }

      if (submitEl) submitEl.disabled = true;
      say('Enregistrement…', 'pending');

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: list } } }
        }
      };

      fetch(ENDPOINT + '?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: REVISION },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (response.status === 202 || response.ok) {
            form.reset();
            say(success, 'ok');
            return null;
          }
          return response.text().then(function (body) {
            var detail = '';
            try {
              var parsed = JSON.parse(body);
              if (parsed && parsed.errors && parsed.errors.length) {
                detail = parsed.errors[0].detail || parsed.errors[0].title || '';
              }
            } catch (e) {
              detail = body ? body.slice(0, 200) : '';
            }
            /* eslint-disable no-console */
            console.log('[DAW newsletter] statut', response.status, body);
            throw new Error('erreur ' + response.status + (detail ? ' — ' + detail : ''));
          });
        })
        .catch(function (error) {
          console.log('[DAW newsletter] échec', error);
          if (submitEl) submitEl.disabled = false;
          say(
            'L’inscription n’a pas pu être enregistrée (' +
              (error && error.message ? error.message : 'réseau') +
              '). Merci de réessayer.',
            'ko'
          );
        });
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-daw-newsletter]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* L'éditeur de thème recharge les sections sans recharger la page. */
  document.addEventListener('shopify:section:load', boot);
})();
